import React from 'react';
import Common from '../components/common/Common';
import NavbarTwo from '../components/navbartwo/NavbarTwo';
import STho from '../components/stho/STho';
import Tho from '../components/tho/Tho';
import "./landing2.css";
 
 

function LandingPage2() {
    return (
        <div>
    <NavbarTwo/>
    <Common/>
    <Tho/>
    <STho/>
        </div>
    )
}

export default LandingPage2
